import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const FloppyIcon = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 18),
    ...svgProps,
    fill: svgProps.fill ?? "none",
    stroke: color ?? svgProps.stroke ?? "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    children: [/*#__PURE__*/jsx("path", {
      d: "m16.5 15.3a1.2 1.2 0 0 1 -1.2 1.2h-12.6a1.2 1.2 0 0 1 -1.2-1.2v-10.3l3.5-3.5h10.3a1.2 1.2 0 0 1 1.2 1.2z"
    }), /*#__PURE__*/jsx("path", {
      d: "m13 10.7h-8v5.8h8zm0-9.2h-6.9v4.6h7v-4.6z"
    })]
  });
};

export { FloppyIcon };
//# sourceMappingURL=floppy.js.map
